<template>
    <aside class="flex flex-col items-start w-full">
        <router-link class="hidden md:block" :to="{ name: 'Project' }">
            <Logo class="w-12" variant="logo-small" />
        </router-link>

        <button
            @click="closeMenu"
            ref="menu-button"
            class="p-3 rounded text-gray-500 hover:text-gray-600 focus:outline-none focus:shadow-outline block md:hidden"
        >
            <icon-svg icon="close" class="w-4 transition duration-150" />
        </button>

        <label
            for="select-project"
            class="text-gray-600 w-full mt-10 flex items-center justify-between w-full"
        >
            <span class="text-sm">Current project...</span>
            <router-link
                :to="{
                    name: 'CreateProject',
                    params: { ...$route.params },
                    query: { ...$route.query },
                }"
                class="underline text-sm transition duration-150 text-secondary dark:text-secondary-300 hover:text-secondary-300 focus:outline-none focus:shadow-outline rounded-sm"
            >
                New
            </router-link>
        </label>

        <BaseSelect
            v-if="!loading"
            class="mt-2"
            id="select-project"
            @input="changeSelected"
            :options="reducedProjectOptions"
            :value="currentProjectId"
            placeholder="Select a project..."
        />

        <div
            aria-label="Current project loading..."
            v-else
            class="mt-2 py-2 px-4 pr-8 border border-gray-300 text-gray-600 rounded-md leading-tight w-full"
        >
            Loading...
        </div>

        <nav class="mt-10 w-full">
            <ul class="flex flex-col space-y-6 w-full">
                <router-link tag="li" :to="{ name: 'Project' }">
                    <main-sidebar-button :current="currentRoute === 'Project'">
                        <template v-slot:icon>
                            <icon-svg icon="project" />
                        </template>
                        <template v-slot:text>Project</template>
                    </main-sidebar-button>
                </router-link>

                <router-link tag="li" :to="{ name: 'Models' }">
                    <main-sidebar-button
                        :current="currentRoute.includes('Model')"
                    >
                        <template v-slot:icon>
                            <icon-svg icon="models" />
                        </template>
                        <template v-slot:text>Models</template>
                    </main-sidebar-button>
                </router-link>

                <main-sidebar-button
                    disabled
                    coming-soon
                    :current="currentRoute.includes('Collection')"
                >
                    <template v-slot:icon>
                        <icon-svg icon="collections" />
                    </template>
                    <template v-slot:text>Collections</template>
                </main-sidebar-button>

                <main-sidebar-button disabled coming-soon>
                    <template v-slot:icon>
                        <icon-svg icon="analytics" />
                    </template>
                    <template v-slot:text>Analytics</template>
                </main-sidebar-button>
            </ul>
        </nav>

        <div v-if="isOwner" class="flex flex-col w-full mt-20">
            <label class="text-gray-500 w-full">Project settings</label>

            <nav class="mt-8 w-full">
                <ul class="flex flex-col space-y-6 w-full">
                    <router-link tag="li" :to="{ name: 'ProjectSettings' }">
                        <main-sidebar-button
                            :current="currentRoute === 'ProjectSettings'"
                        >
                            <template v-slot:icon>
                                <icon-svg icon="settings" />
                            </template>
                            <template v-slot:text>Settings</template>
                        </main-sidebar-button>
                    </router-link>

                    <router-link tag="li" :to="{ name: 'Team' }">
                        <main-sidebar-button :current="currentRoute === 'Team'">
                            <template v-slot:icon>
                                <icon-svg icon="team" />
                            </template>
                            <template v-slot:text>Team</template>
                        </main-sidebar-button>
                    </router-link>
                </ul>
            </nav>
        </div>
    </aside>
</template>

<script>
import MainSidebarButton from "./MainSidebarButton";
import {
    myProjects,
    authenticationState,
    currentProject,
    loading,
    error,
} from "@/mixins";
import { updateAuthenticationState } from "@/graphql/mutations";

export default {
    name: "MainSidebar",
    mixins: [myProjects, authenticationState, currentProject, loading],
    components: {
        MainSidebarButton,
    },
    computed: {
        currentRoute() {
            return this.$route.name;
        },
    },
    methods: {
        async changeSelected(projectId) {
            console.log("changeselected");
            try {
                await this.$apollo.mutate({
                    mutation: updateAuthenticationState,
                    variables: {
                        selectedProject: projectId,
                    },
                });

                return this.$router.push({
                    name: "Project",
                    query: { project: projectId },
                });
            } catch (error) {
                this.handleError(error);
            }
        },
        closeMenu() {
            this.$refs["menu-button"].blur();
            this.$emit("toggle-sidebar");
        },
    },
};
</script>
